import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const AlertIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
)
const XIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
)

const ConfirmationModal = ({
    display,
    toggle,
    title,
    message,
    confirmAction,
    confirmText,
    cancelText,
    tone = 'danger',   // 'danger' (default, destructive) | 'primary'
    size,
    // Optional field(s) rendered between the message and the buttons — used
    // where confirming also captures something (e.g. a cancellation reason).
    children,
    confirmDisabled = false,
}) => {

    const { t } = useTranslation();
    const _title = title || t('common.confirm');
    const _message = message || t('confirmation.defaultMessage');
    const _confirmText = confirmText || t('common.yes');
    const _cancelText = cancelText || t('common.no');

    const handleConfirmAction = () => {
        confirmAction()
        toggle(false)
    }

    return (
        <Modal
            show={display}
            onHide={() => toggle(false)}
            backdropClassName="level-2"
            contentClassName="sbr-modal"
            centered
            size={size}
        >
            <Modal.Body>
                <div className="sbr">
                    <div className="sbm-head">
                        <div className={`ico ${tone === 'danger' ? 'warn' : ''}`}><AlertIcon /></div>
                        <div className="htx">
                            <div className="ttl">{_title}</div>
                            <div className="sub">{_message}</div>
                        </div>
                        <button type="button" className="x" onClick={() => toggle(false)} aria-label={t('common.close')}><XIcon /></button>
                    </div>
                    {children && <div className="sbm-body">{children}</div>}
                    <div className="sbm-foot">
                        <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={() => toggle(false)}>{_cancelText}</button>
                        <button type="button" disabled={confirmDisabled} className={`btn-sbr btn-sm-sbr ${tone === 'danger' ? 'btn-danger-sbr' : 'btn-primary-sbr'}`} onClick={handleConfirmAction}>{_confirmText}</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmationModal
